export default __webpack_public_path__ + "static/media/2-colocada.ca7304b3.png";